import { lazyNamed } from 'src/utils/lazyNamed';

export const ScreenshotManagement = {
  ScreenshotManagementList: lazyNamed(() => import('./containers/ScreenshotManagementList'), 'ScreenshotManagementList'),
};
